'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

interface CustomCheckboxProps {
  checked?: boolean;
  indeterminate?: boolean;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked?: boolean) => void;
  [key: string]: any;
}

const TableCheckbox = React.forwardRef<HTMLInputElement, CustomCheckboxProps>(
  function TableCheckbox(props, ref) {
    const { checked = false, onChange } = props;
    const inputRef = React.useRef<HTMLInputElement>(null);

    // Merge the forwarded ref with our internal ref
    React.useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e);
      }
    };

    return (
      <div className="flex items-center">
        <input
          type="checkbox"
          ref={inputRef}
          checked={checked}
          onChange={handleChange}
          className="hidden"
        />
        <div
          className={`w-4 h-4 flex items-center justify-center border rounded transition-colors cursor-pointer ${
            checked
              ? 'bg-sky-600 border-sky-600 hover:bg-sky-800'
              : 'bg-white border-neutral-300'
          }`}
          onClick={(e) => {
            e.stopPropagation();
            if (inputRef.current) {
              inputRef.current.click();
            }
          }}
          aria-hidden="true"
        >
          {checked && (
            <Icon icon={faCheck} className="text-white text-[10px]" />
          )}
        </div>
      </div>
    );
  }
);

// Cast needed for MUI X v7 DataGrid slot compatibility:
// MUI's CheckboxProps expects Ref<HTMLButtonElement> but our checkbox uses HTMLInputElement
export default TableCheckbox as any;
